import React, { useEffect, useState, MouseEvent, ChangeEvent } from 'react';
import TotalProduction from '../../../assets/images/TotalProduction.svg';
import TotalInstalled from '../../../assets/images/TotalInstalled.svg';
import TotalLive from '../../../assets/images/TotalLive.svg';
import TotalAlert from '../../../assets/images/TotalAlert.svg';
import Map from '../../../assets/images/Map.svg';
import Filter from '../../../assets/images/Filter.svg';
import Add from '../../../assets/images/Add.svg';
import Assign from '../../../assets/images/Assign.svg';
import Download from '../../../assets/images/Download.svg';
import WhiteCloseicon from '../../../assets/images/WhiteCloseIcon.svg';
import HoverOptions from '../../../assets/images/hoverOptions.svg';
import ActiveOptions from '../../../assets/images/activeOptions.svg';
import HoverEdit from '../../../assets/images/hoverEdit.svg';
import HoverAssign from '../../../assets/images/hoverAssign.svg';
import HoverDelete from '../../../assets/images/hoverDelete.svg';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import Editpage from './edit';
import UserList from '../../../assets/images/userList-Dashboard.svg';
import Manufacture from '../../../assets/images/manufature-Dashboard.svg';
import UnRegister from '../../../assets/images/UnRegistered-Dashboard.svg';
import Register from '../../../assets/images/Registere-Dashboard.svg';
import Dealer from '../../../assets/images/dealer-Dashboard.svg';
import User from '../../../assets/images/User-Dashboard.svg';
import Subscription from '../../../assets/images/subscription-Dashboard.svg';

import {
  Button,
  Checkbox,
  Chip,
  Drawer,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Divider,
  Menu,
  MenuItem,
  Paper,
  Popover,
  Select,
  SelectChangeEvent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  IconButton,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import PaginationComponent from '../../../components/Pagination';
import { Status } from '../../../components';
import Options from '../../../assets/images/Options.svg';
import EditIcon from '../../../assets/images/edit_Icon.svg';
import AssignIcon from '../../../assets/images/assign_icon (2).svg';
import DeleteIcon from '../../../assets/images/delete_icon.svg';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import ActionButtons from '../../../components/actionbutton';

const names = [
  'marketing manager',
  'data alchemist',
  'innovation catalyst',
  'talent whisperer',
  'customer alchemist',
  'risk weaver',
  'brand narrator',
  'sustainability architect',
];

const chipName = [
  'Option 1',
  'Option 2',
  'Option 3',
  'Option 4',
  'Option 5',
  'Option 6',
  'Option 7',
];

const optionName = ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5'];

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import { ExpandMore } from '@mui/icons-material';
import userProfile from '../../../assets/images/userProfile.svg';
import createAxiosInstance from '../../../api';
import DashboardHeaderItem from '../../../components/dashboardheader';
import DeleteConfirmationDialog from '../../../components/Popup';
import { check } from 'prettier';
import { closeBlackIcon } from '../../../assets/images';
import { useHook as DashboardHook } from './useHook';

interface Props {
  pagePermissionIDs: unknown;
}
const Dashboard: React.FC<Props> = ({ pagePermissionIDs }) => {
  const { name, id } = useParams();
  const userRole = localStorage.getItem('role');
  const {
    getManufacturedUnitsCount,
    getUnregisteredUnitsCount,
    getDealerUnregisteredUnitsCount,
    getRegisteredUnitsCount,
    getDealerRegisteredUnitsCount,
    getNumberOfUsers,
    getNumberOfCustomers,
    getNumberOfDealers,
    getNumberOfActiveSubscription,
  } = DashboardHook();
  const [dashboardTotalCounts, setDashboardTotalCount] = useState({
    manufacturedUnitsResponse: 0,
    unregisteredUnitsResponse: 0,
    registeredUnitsResponse: 0,
    usersResponse: 0,
    customersResponse: 0,
    dealersResponse: 0,
    activeSubscriptionsResponse: 0,
  });
  const canUserlistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('users::list');

  const canPermissionManufacturedCount =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('dashboard::manufacturedCount');
  const canPermissionUnregisteredCount =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('dashboard::unregisteredCount');
  const canPermissionRegisteredCount =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('dashboard::registeredCount');
  const canPermissionUsers =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('dashboard::numberOfUsers');
  const canPermissionCustomers =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('dashboars::numberOfCustomers');
  const canPermissionDealers =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('dashboard::numberOfDealers');
  const canPermissionActiveSubscription =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('dashboard::numberOfActiveSubscription');

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [dashboardDatas, setDashboardDatas]: any = useState([]);
  const [open, setOpen] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  // Filter Drawer Form Field useState //
  const [isFilterValid, setIsFilterValid] = useState<boolean>(false);
  const [dealername, setdealerName] = React.useState<string[]>([]);
  const [filteredRoles, setFilteredRoles] = useState<string[]>([]);
  const [selectedRoles, setSelectedRoles] = useState<string[]>([]);
  const [activeChip, setActiveChip] = useState<boolean[]>(
    Array(chipName.length).fill(false),
  );
  const [selectedChipName, setSelectedChipName] = useState<string[]>([]);

  // Table kebab menu hover useState //

  const [filterDisplay, setFilterDisplay] = useState<string[]>([]);
  const [imageHoverd, setImageHoverd] = useState(null);
  const [imageActive, setimageActive] = useState(null);
  const [menuItemHoverd, setMenuItemHovered] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerFilter, setDrawerFilter] = useState(false);
  const [hardwareId, setHardwareId] = useState(''); // State for hardware ID
  const [dealerName, setDealerName] = React.useState<string[]>([]); // State for dealer name
  const [selectedRadio, setSelectedRadio] = useState(''); // State for selected radioconst [selectedChipsets, setSelectedChipsets] = useState([]); // State for selected chipsets

  //Assign Drawer Form Field useState

  const [isFormValid, setIsFormValid] = useState(false);
  const [assignDealer, setAssignDealer] = useState<any[]>([]);
  const [assignActiveChip, setAssignActiveChip] = useState<boolean[]>(
    Array(chipName.length).fill(false),
  );
  const [assignErrors, setAssignErrors] = useState<any>('');
  const [assignSelectChip, setAssignSelectChip] = useState<string[]>([]);
  const [assignData, setAssignData] = useState<any>({
    hardwareId: '',
    radioAssign: '',
    assignCheck: [],
    assignDealerName: [],
    assignChip: [],
  });

  interface UserDataList {
    userID: string;
    userName: string;
    firstName: string;
    lastName: string;
    avatar: string;
  }

  const [filteredData, setFilteredData] = useState<UserDataList[]>([]);
  const [selectedusername, setSelectedusername] = useState<any>('');
  const [userData, setUserdata] = useState<any[]>([]);
  const axiosInstance = createAxiosInstance();
  const [openDealerName, setOpenDealerName] = useState(false);
  const [search, setSearch] = useState<string>('');

  const handleCloseDealerName = () => {
    setOpenDealerName(false);
    setFilteredData(userData);
  };

  const getUserData = async () => {
    if (canUserlistPermission) {
      await axiosInstance
        .post('/listUser', {})
        .then((response) => {
          if (response?.data?.data) {
            setUserdata(response?.data?.data);
            setFilteredData(response?.data?.data);
          }
        })
        .catch(() => {
          setUserdata([]);
          setFilteredData([]);
        });
    }
  };

  // useEffect(() => {
  //   getUserData();
  // }, [canUserlistPermission]);

  const handleUserSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query: string = event.target.value.toLowerCase();
    const filtered: UserDataList[] = userData?.filter((user) =>
      `${user.firstName + user.lastName}`.toLowerCase().includes(query),
    );
    setFilteredData(filtered);
  };

  const handleuser = (userData: any): void => {
    if (userData) {
      setSelectedusername(userData);
      setAssignDealer([userData]);
    } else {
      setSelectedusername('');
    }
    handleCloseDealerName();
  };

  // const handleChipsetDelete = (chipToDelete: any) => () => {
  //   setSelectedChipsets((chips) =>
  //     chips.filter((chip) => chip !== chipToDelete),
  //   );
  //   validateForm();
  // };

  // const handleChangeCheck = (index: any) => {
  //   const newChecked = [...checked];
  //   newChecked[index] = !newChecked[index];
  //   setChecked(newChecked);
  //   validateForm();
  // };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    // Handle form submission logic here
  };
  // const toggleDrawer = (newOpen: boolean) => () => {
  //   setOpen(newOpen);
  // };
  // const handleOpenDrawer = () => {
  //   handleClose();
  //   toggleDrawer(true);
  //   // setDrawerOpen(true);
  // };

  const handleAssignOpenDrawer = () => {
    handleClose();
    //  toggleDrawer(true);
    setDrawerOpen(true);
  };

  const handleCloseFilter = () => {
    setDrawerFilter(false);
  };

  const handleDelete = () => {
    console.info('You clicked the delete icon.');
  };

  const handleFIlterClick = (newOpen: boolean) => {
    setFilterOpen(newOpen);
  };

  const handleFIlterCancel = (newOpen: boolean) => {
    setFilterOpen(newOpen);
    setSelectedChipName([]);
    setActiveChip(Array(chipName.length).fill(false));
    setSelectedRoles([]);
    setFilterDisplay([]);

    setIsFilterValid(false);
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const handleRowsPerPageChange = (value: number) => {
    setRowsPerPage(value);
    setCurrentPage(1);
    const startIndex = (1 - 1) * value;
    const endIndex = startIndex + value;
    const pageData = dashboardData.slice(startIndex, endIndex);
    setDashboardDatas(pageData);

    const totalPage = Math.ceil(dashboardData.length / value);
    setTotalPages(totalPage);
  };
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    const startIndex = (page - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const pageData = dashboardData.slice(startIndex, endIndex);
    setDashboardDatas(pageData);
  };
  const dashboardData = [
    {
      hardware: '1.24.2_Neutralization Tank Agitator- Panel-4',
      gateway: '2382394',
      type: 'Type',
      status: 'active',
    },
    {
      hardware: '1.24.2_Neutralization Tank Agitator- Panel-4',
      gateway: '2382394',
      type: 'Type',
    },
    {
      hardware: '1.24.2_Neutralization Tank Agitator- Panel-4',
      gateway: '2382394',
      type: 'Type',
      status: 'active',
    },
    {
      hardware: '1.24.2_Neutralization Tank Agitator- Panel-4',
      gateway: '2382394',
      type: 'Type',
    },
    {
      hardware: '1.24.2_Neutralization Tank Agitator- Panel-4',
      gateway: '2382394',
      type: 'Type',
      status: 'active',
    },
    {
      hardware: '1.24.2_Neutralization Tank Agitator- Panel-4',
      gateway: '2382394',
      type: 'Type',
    },
  ];

  const getDashboardDealerDataTotals = async (): Promise<void> => {
    try {
      const [unregisteredUnitsResponse, registeredUnitsResponse] =
        await Promise.all([
          getDealerUnregisteredUnitsCount(),
          getDealerRegisteredUnitsCount(),
        ]);
      setDashboardTotalCount({
        manufacturedUnitsResponse: 0,
        unregisteredUnitsResponse: unregisteredUnitsResponse
          ? unregisteredUnitsResponse
          : 0,
        registeredUnitsResponse: registeredUnitsResponse
          ? registeredUnitsResponse
          : 0,
        usersResponse: 0,
        customersResponse: 0,
        dealersResponse: 0,
        activeSubscriptionsResponse: 0,
      });
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  };

  const getDashboardDataTotals = async (): Promise<void> => {
    try {
      const [
        manufacturedUnitsResponse,
        unregisteredUnitsResponse,
        registeredUnitsResponse,
        usersResponse,
        customersResponse,
        dealersResponse,
        activeSubscriptionsResponse,
      ] = await Promise.all([
        getManufacturedUnitsCount(),
        getUnregisteredUnitsCount(),
        getRegisteredUnitsCount(),
        getNumberOfUsers(),
        getNumberOfCustomers(),
        getNumberOfDealers(),
        getNumberOfActiveSubscription(),
      ]);
      setDashboardTotalCount({
        manufacturedUnitsResponse: manufacturedUnitsResponse
          ? manufacturedUnitsResponse
          : 0,
        unregisteredUnitsResponse: unregisteredUnitsResponse
          ? unregisteredUnitsResponse
          : 0,
        registeredUnitsResponse: registeredUnitsResponse
          ? registeredUnitsResponse
          : 0,
        usersResponse: usersResponse ? usersResponse : 0,
        customersResponse: customersResponse ? customersResponse : 0,
        dealersResponse: dealersResponse ? dealersResponse : 0,
        activeSubscriptionsResponse: activeSubscriptionsResponse
          ? activeSubscriptionsResponse
          : 0,
      });
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
  };

  useEffect(() => {
    if (dashboardData) {
      const totalPage = Math.ceil(dashboardData.length / rowsPerPage);
      setTotalPages(totalPage);
      const startIndex = (currentPage - 1) * rowsPerPage;
      const endIndex = startIndex + rowsPerPage;
      const pageData = dashboardData.slice(startIndex, endIndex);
      setDashboardDatas(pageData);
    }
    if (userRole !== 'dealer') {
      getDashboardDataTotals();
    } else {
      getDashboardDealerDataTotals();
    }
  }, []);

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event: any, index: any) => {
    setimageActive(index);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setimageActive(null);
    setImageHoverd(null);
    setAnchorEl(null);
    setMenuItemHovered(null);
  };
  const handleOpenDrawer = () => {
    handleClose();
    setIsDrawerOpen(true);
  };
  const handlecustomclose = () => {
    setIsDrawerOpen(false);
  };
  const handleDeleteMenuItemClick = () => {
    setIsDeleteDialogOpen(true);
    handleClose();
  };

  const handleDeleteConfirm = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDeleteCancel = () => {
    setIsDeleteDialogOpen(false);
  };
  // Filter Drawer DealarName selectbox useEffect //

  useEffect(() => {
    setFilteredRoles(names);
  }, []);

  // Filter Drawer Form field function //

  const filterValidate = () => {
    if (selectedChipName.length == 0 || selectedRoles.length == 0) {
      setIsFilterValid(true);
    }
  };

  const handleFillterApply = () => {
    const merged = [...selectedChipName, ...selectedRoles];
    setFilterDisplay(merged);
    if (selectedChipName.length !== 0 || selectedRoles.length !== 0) {
      setFilterOpen(false);
    }
  };

  const handleChangeDealerName = (event: any) => {
    const {
      target: { value },
    } = event;
    setdealerName(typeof value === 'string' ? value.split(',') : value);
  };

  const handleRoleSelection = (roleName: string | undefined) => {
    if (!roleName) return;
    setSelectedRoles((prevSelectedRoles) => {
      if (prevSelectedRoles.includes(roleName)) {
        const updatedRoles = prevSelectedRoles.filter(
          (roles) => roles !== roleName,
        );
        return updatedRoles;
      } else {
        const updatedRoles = [...prevSelectedRoles, roleName];
        return updatedRoles;
      }
    });
    filterValidate();
  };

  const handleRoleUserSearch = (event: any) => {
    const query = event.target.value.toLowerCase();
    const filtered = names.filter((role) => role.toLowerCase().includes(query));
    setFilteredRoles(filtered);
  };

  const ChipsetActivevalue = (index: number) => {
    setActiveChip((prevActiveChipName) => {
      const activeChipName = [...prevActiveChipName];
      activeChipName[index] = !activeChipName[index];
      return activeChipName;
    });

    setSelectedChipName((prevSelectedChipName) => {
      const SelectedChipvalue = [...prevSelectedChipName];
      if (activeChip[index]) {
        const chipIndex = SelectedChipvalue.indexOf(chipName[index]);
        if (chipIndex !== -1) {
          SelectedChipvalue.splice(chipIndex, 1);
        }
      } else {
        SelectedChipvalue.push(chipName[index]);
      }
      return SelectedChipvalue;
    });
    filterValidate();
  };

  const filterDisplayChange = (username: any): void => {
    if (chipName.includes(username)) {
      const optionIndex = chipName.indexOf(username);
      activeChip[optionIndex] = false;
      const updateData = selectedChipName.filter(
        (item: any) => item !== username,
      );
      setSelectedChipName(updateData);
    }

    if (selectedRoles) {
      const updatedData = selectedRoles.filter(
        (item: any) => item !== username,
      );
      setSelectedRoles(updatedData);
    }

    if (username) {
      if (filterDisplay.includes(username)) {
        const updatedData = filterDisplay.filter(
          (item: any) => item !== username,
        );
        setFilterDisplay(updatedData);
      } else {
        const adddata = [...filterDisplay, username];
        const uniqueEventNames = [...new Set(adddata)];
        setFilterDisplay(uniqueEventNames);
      }
    } else {
      return;
    }
  };

  //Assign Drawer Form Field

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setAssignErrors('');
    setAssignData({
      hardwareId: '',
      radioAssign: '',
      assignCheck: [],
      assignDealerName: [],
      assignChip: [],
    });

    setSelectedusername('');
    setAssignActiveChip(Array(chipName.length).fill(false));
    setIsFormValid(false);
  };

  const assignValidateForm = () => {
    // Basic validation for demonstration purposes
    if (
      assignData.hardwareId ||
      assignData.assignDealerName ||
      assignData.radioAssign ||
      assignData.assignCheck ||
      assignActiveChip
    ) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  };

  const assignSubmitValidate = (assignData: any) => {
    const error: any = {};
    if (!assignData.hardwareId.trim()) {
      error.hardwareId = 'HardwareId is required';
    }

    if (assignData.assignDealerName.length === 0) {
      error.DealerName = 'DealerName is required';
    }
    if (!assignData.radioAssign.trim()) {
      error.radioassign = 'Select The Option';
    }
    if (assignSelectChip.length === 0) {
      error.assignChip = 'Select The Option';
    }
    if (assignData.assignCheck.length === 0) {
      error.assignCheck = 'Select The Option';
    }
    return error;
  };

  const handleAssignChange = (event: any) => {
    const { name, value, type, checked } = event.target;

    const updatedValue = type === 'checkbox' ? checked : value;

    const updatedState =
      name === 'assignCheck'
        ? {
            ...assignData,
            [name]: checked
              ? [...assignData[name], value]
              : assignData[name].filter((item: string) => item !== value),
          }
        : { ...assignData, [name]: updatedValue };

    setAssignData(updatedState);

    assignValidateForm();
  };

  const handleAssignChipActive = (index: number) => {
    setAssignActiveChip((prevAssignActiveChip: any) => {
      const assignActiveShipName = [...prevAssignActiveChip];
      assignActiveShipName[index] = !assignActiveShipName[index];
      return assignActiveShipName;
    });

    setAssignSelectChip((prevSelectedChip: any) => {
      const SelectedChipvalue = [...prevSelectedChip];
      if (assignActiveChip[index]) {
        const chipIndex = SelectedChipvalue.indexOf(chipName[index]);
        if (chipIndex !== -1) {
          SelectedChipvalue.splice(chipIndex, 1);
        }
      } else {
        SelectedChipvalue.push(chipName[index]);
      }
      return SelectedChipvalue;
    });
    assignValidateForm();
  };

  useEffect(() => {
    setAssignData((prevState: any) => ({
      ...prevState,
      assignDealerName: assignDealer,
      assignChip: assignSelectChip,
    }));
  }, [assignDealer, assignSelectChip]);

  const handleAssignSubmit = (event: any) => {
    event.preventDefault();
    const errors = assignSubmitValidate(assignData);
    if (Object.keys(errors).length === 0) {
      console.log(assignData);
      setAssignErrors({});
      handleCloseDrawer();
    } else {
      setAssignErrors(errors);
    }
  };

  // Table kebab menu hover function //

  const imageMouseEnter = (id: any) => {
    setImageHoverd(id);
  };

  const imageMouseLeave = () => {
    setImageHoverd(null);
  };

  const MenuItemEnter = (item: any) => {
    setMenuItemHovered(item);
  };

  const MenuItemLeave = () => {
    setMenuItemHovered(null);
  };

  //search
  const handleSearchChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const search = event.target.value;
    // Allow only letters, numbers, and spaces
    const regex = /^[a-zA-Z0-9 ]*$/;
    if (regex.test(search)) {
      setSearch(search);

      // if (!search) {
      //   handleGetUnit(currentPage, rowsPerPage, search);
      // } else {
      //   setCurrentPage(1);
      // }
    }
  };

  return (
    <>
      <section
        className={
          userRole === 'dealer'
            ? 'dashboard_header-section dealer-dashboard_header-section'
            : 'dashboard_header-section'
        }
      >
        {canPermissionManufacturedCount && userRole !== 'dealer' && (
          <div className="dashboard_header-section-card card-manufactured ">
            <div>
              <h4>{dashboardTotalCounts?.manufacturedUnitsResponse || 0}</h4>
              <h5>Manufactured units</h5>
            </div>
            <img src={Manufacture} alt="Manufacture img" />
          </div>
        )}

        {canPermissionUnregisteredCount && (
          <div className="dashboard_header-section-card card-unregistered ">
            <div>
              <h4>{dashboardTotalCounts?.unregisteredUnitsResponse || 0}</h4>
              <h5>Unregistered Units</h5>
            </div>
            <img src={UnRegister} alt="UnRegister img" />
          </div>
        )}

        {canPermissionRegisteredCount && (
          <div className="dashboard_header-section-card card-registered">
            <div>
              <h4>{dashboardTotalCounts?.registeredUnitsResponse || 0}</h4>
              <h5>Registered Units</h5>
            </div>
            <img src={Register} alt="UserList img" />
          </div>
        )}
      </section>

      {userRole !== 'dealer' && (
        <>
          <p className="dashboard-user_analysis">User Analysis</p>

          <section className="dashboard_header-section">
            {canPermissionCustomers && (
              <div className="dashboard_header-section-card card-customer">
                <div>
                  <h4>{dashboardTotalCounts?.customersResponse || 0}</h4>
                  <h5>Number of customers</h5>
                </div>
                <img src={UserList} alt="UserList img" />
              </div>
            )}

            {canPermissionDealers && (
              <div className="dashboard_header-section-card card-dealer">
                <div>
                  <h4>{dashboardTotalCounts?.dealersResponse || 0}</h4>
                  <h5>Number of Dealers</h5>
                </div>
                <img src={Dealer} alt="Dealer img" />
              </div>
            )}

            {canPermissionUsers && (
              <div className="dashboard_header-section-card card-user">
                <div>
                  <h4>{dashboardTotalCounts?.usersResponse || 0}</h4>
                  <h5>Number of Users</h5>
                </div>
                <img src={User} alt="UserList img" />
              </div>
            )}

            {canPermissionActiveSubscription && (
              <div className="dashboard_header-section-card card-subscriptions">
                <div>
                  <h4>
                    {dashboardTotalCounts?.activeSubscriptionsResponse || 0}
                  </h4>
                  <h5>Active subscriptions</h5>
                </div>
                <img src={Subscription} alt="Subscription img" />
              </div>
            )}
          </section>
        </>
      )}

      {/* <header className="dashboard_topheader">
        {canPermissionManufacturedCount && (
          <DashboardHeaderItem
            iconSrc={TotalProduction}
            title="Manufactured Unit"
            value={dashboardTotalCounts?.manufacturedUnitsResponse || 0}
          />
        )}

        {canPermissionRegisteredCount && (
          <DashboardHeaderItem
            iconSrc={TotalInstalled}
            title="Registered Units"
            value={dashboardTotalCounts?.registeredUnitsResponse || 0}
          />
        )}

        {canPermissionUnregisteredCount && (
          <DashboardHeaderItem
            iconSrc={TotalProduction}
            title="Unregistered Units"
            value={dashboardTotalCounts?.unregisteredUnitsResponse || 0}
          />
        )}

        {canPermissionUsers && (
          <DashboardHeaderItem
            iconSrc={TotalInstalled}
            title="Users"
            value={dashboardTotalCounts?.usersResponse || 0}
          />
        )}

        {canPermissionCustomers && (
          <DashboardHeaderItem
            iconSrc={TotalProduction}
            title="Customers"
            value={dashboardTotalCounts?.customersResponse || 0}
          />
        )}

        {canPermissionDealers && (
          <DashboardHeaderItem
            iconSrc={TotalInstalled}
            title="Dealers"
            value={dashboardTotalCounts?.dealersResponse || 0}
          />
        )}

        {canPermissionActiveSubscription && (
          <DashboardHeaderItem
            iconSrc={TotalProduction}
            title="Active Subscriptions"
            value={dashboardTotalCounts?.activeSubscriptionsResponse || 0}
          />
        )} */}

      {/* <DashboardHeaderItem
          iconSrc={TotalInstalled}
          title="Total Installed"
          value={244}
        />
        <DashboardHeaderItem
          iconSrc={TotalLive}
          title="Total Live"
          value={28}
        />
        <DashboardHeaderItem
          iconSrc={TotalAlert}
          title="Total Alert"
          value={142}
        /> */}
      {/* </header> */}
      {/* <div className="dashboard-header">
        <div className="dashboard-header_card-container">
          <div className="dashboard-header_card">
            <ActionButtons image={Map} title={'Map'} />
          </div>
          <div className="dashboard-header_card">
            <ActionButtons
              image={Filter}
              title={'Filter'}
              action={() => handleFIlterClick(true)}
              activeData={filterDisplay}
            />
          </div>
          <div className="dashboard-header_card">
            <ActionButtons image={Add} title={'Add'} />
          </div>
          <div className="dashboard-header_card">
            <ActionButtons image={Assign} title={'Assign'} />
          </div>
          <div className="dashboard-header_card">
            <ActionButtons image={Download} title={'Download'} />
          </div>
        </div>
        <div className="table-header-btn">
          <TextField
            variant="outlined"
            placeholder="Search"
            value={search}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: <SearchIcon />,
            }}
            className="search-input"
          />
        </div>
      </div>

      <div>
        {filterDisplay.map((event, index) => (
          <div key={index} className="filterlist">
            <p>{event}</p>
            <Button onClick={() => filterDisplayChange(event)}>
              <img src={closeBlackIcon} alt="Delete Icon" width={13} />
            </Button>
          </div>
        ))}
      </div>

      <TableContainer className="dashboard_table-container " component={Paper}>
        <Table>
          <TableHead className="dashboard_table-header">
            <TableRow>
              <TableCell className="dashboard_table-header_hardware">
                Hardware ID
              </TableCell>
              <TableCell className="dashboard_table-header_gateway">
                Gateway ID
              </TableCell>
              <TableCell className="dashboard_table-header_type">
                Type
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dashboardDatas &&
              dashboardDatas?.map((data: any, index: any) => (
                <TableRow key={index}>
                  <TableCell>
                    <div className="dashboard_tablerow_hardware">
                      <p>{data?.hardware}</p>
                      <Status status={data?.status} />
                    </div>
                  </TableCell>
                  <TableCell>
                    <p>{data?.gateway}</p>
                  </TableCell>
                  <TableCell>
                    <div className="dashboard_tablerow_type">
                      <p>{`${data?.type} ${index + 1}`}</p>
                      <button
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={(e) => handleClick(e, index)}
                      >
                        {imageActive === index ? (
                          <img
                            key={index}
                            src={ActiveOptions}
                            alt="Option img"
                          />
                        ) : (
                          <img
                            key={index}
                            src={imageHoverd === index ? HoverOptions : Options}
                            alt="Option img"
                            onMouseEnter={() => imageMouseEnter(index)}
                            onMouseLeave={imageMouseLeave}
                          />
                        )}
                      </button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationComponent
        rowsPerPageOptions={[5, 10, 20, 30]}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        totalPages={totalPages}
      />
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className="dashboard-menu"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={handleOpenDrawer}
          className="menuItem edit_icon"
          onMouseEnter={() => MenuItemEnter('edit')}
          onMouseLeave={MenuItemLeave}
        >
          <img
            src={menuItemHoverd === 'edit' ? HoverEdit : EditIcon}
            alt="Edit"
          />
          Edit
        </MenuItem>
        <Drawer anchor="right" open={isDrawerOpen} onClose={handlecustomclose}>
          <Editpage isOpen={isDrawerOpen} onClose={handlecustomclose} />
        </Drawer>
        <MenuItem
          onClick={handleAssignOpenDrawer}
          className="menuItem assign_icon"
          onMouseEnter={() => MenuItemEnter('assign')}
          onMouseLeave={MenuItemLeave}
        >
          <img
            src={menuItemHoverd === 'assign' ? HoverAssign : AssignIcon}
            alt="Edit"
          />
          Assign
        </MenuItem>
        <MenuItem
          onClick={handleDeleteMenuItemClick}
          className="menuItem delete_icon"
          onMouseEnter={() => MenuItemEnter('delete')}
          onMouseLeave={MenuItemLeave}
        >
          <img
            src={menuItemHoverd === 'delete' ? HoverDelete : DeleteIcon}
            alt="delete"
          />
          Delete
        </MenuItem>
      </Menu>

      <DeleteConfirmationDialog
        open={isDeleteDialogOpen}
        handleClose={handleDeleteCancel}
        handleDelete={handleDeleteConfirm}
        page="item"
        btntext="Delete"
      />

      <Drawer open={drawerOpen} anchor="right" onClose={handleCloseDrawer}>
        <div className="assign-drawer">
          <form onSubmit={handleAssignSubmit}>
            <div className="drawer_header">
              <h3 className="drawer_header_content">Assign</h3>
            </div>

            <div className="drawer_header_line">
              <div className="drawer_body">
                <div className="drawer_body_div">
                  <p className="drawer_body_content">Enter Hardware ID</p>
                  <TextField
                    name="hardwareId"
                    id="outlined-basic"
                    className="drawer_input_text"
                    value={assignData.hardwareId}
                    onChange={handleAssignChange}
                    error={assignErrors.hardwareId}
                  />
                  {assignErrors.hardwareId && (
                    <span className="assign-drawer-error">
                      {assignErrors.hardwareId}
                    </span>
                  )}
                </div>

                <div className="drawer_selecte-div">
                  <h6 className="drawer_selecte_content">Dealer Name</h6>
                  <Select
                    open={openDealerName}
                    onOpen={() => setOpenDealerName(true)}
                    onClose={handleCloseDealerName}
                    name="assignDealerName"
                    id="demo-simple-select-filled"
                    className="drawer_input_select"
                    multiple
                    displayEmpty
                    value={assignDealer}
                    renderValue={() => (
                      <div className="selecter_dropdown_placeholder">
                        {selectedusername.length === 0 ? (
                          'Select Dealer'
                        ) : (
                          <div className="global_audilog_user_profile_cheked">
                            <img
                              src={
                                selectedusername?.avatar
                                  ? selectedusername?.avatar
                                  : userProfile
                              }
                              width={24}
                              alt="User Profile"
                            />{' '}
                            <p>{`${selectedusername?.firstName} ${selectedusername?.lastName}`}</p>
                          </div>
                        )}
                      </div>
                    )}
                    onChange={handleAssignChange}
                    IconComponent={ExpandMore}
                    error={assignErrors.DealerName}
                  >
                    <div className="user_name-popover">
                      <div className="user_name-popover-search">
                        <TextField
                          className="user_name-popover-search_input search-input"
                          variant="outlined"
                          placeholder="Search user"
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <SearchIcon className="search_icon" />
                            ),
                          }}
                          onChange={handleUserSearch}
                        />
                      </div>
                      {filteredData.map((user, index) => (
                        <Button
                          key={index}
                          onClick={() => {
                            handleuser(user);
                          }}
                          className={
                            selectedusername.userID === user.userID
                              ? 'global_audilog_user user_checked'
                              : 'global_audilog_user'
                          }
                        >
                          <div className="global_audilog_user_profile">
                            <img
                              src={user?.avatar ? user?.avatar : userProfile}
                              width={24}
                              alt="User Profile"
                            />{' '}
                            <p>{`${user?.firstName} ${user?.lastName}`}</p>
                          </div>
                          {selectedusername.userID === user.userID && (
                            <IconButton className="iconButton">
                              <DoneIcon className="doneIcon" />
                            </IconButton>
                          )}
                        </Button>
                      ))}
                    </div>
                  </Select>
                  {assignErrors.DealerName && (
                    <span className="assign-drawer-error">
                      {assignErrors.DealerName}
                    </span>
                  )}
                </div>

                <div className="drawer_radio_div">
                  <h5 className="drawer_selecte_content">
                    Header -Radio Buttons
                  </h5>
                  <div>
                    <FormControl>
                      <RadioGroup aria-labelledby="demo-radio-buttons-group-label">
                        {optionName.map((option, index) => (
                          <FormControlLabel
                            value={option}
                            key={index}
                            control={
                              <Radio
                                name="radioAssign"
                                size="small"
                                checked={assignData.radioAssign === option}
                                onChange={handleAssignChange}
                                id={`${option}-radio`}
                              />
                            }
                            label={
                              <Typography
                                className="radio_assign-typography"
                                sx={{
                                  color:
                                    assignData.radioAssign === option
                                      ? 'black'
                                      : 'inherit',
                                }}
                              >
                                {option}
                              </Typography>
                            }
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {assignErrors.radioassign && (
                    <span className="assign-drawer-error">
                      {assignErrors.radioassign}
                    </span>
                  )}
                </div>

                <div className="dashboard-filter_drawer-chipset">
                  <h5>Header-Chipsets</h5>
                  <div className="dashboard-filter_drawer-chipset-list">
                    <Stack className="dashboard-filter_drawer-stack">
                      {chipName.map((chipName, index) => (
                        <Chip
                          key={index}
                          label={chipName}
                          className={
                            assignActiveChip[index]
                              ? 'dashboard-filter_drawer-stack-list_active'
                              : 'dashboard-filter_drawer-stack-list'
                          }
                          onClick={() => handleAssignChipActive(index)}
                          deleteIcon={
                            <img
                              src={
                                assignActiveChip[index] ? WhiteCloseicon : Add
                              }
                              alt={assignActiveChip[index] ? 'Cancel' : 'Add'}
                            />
                          }
                          onDelete={() => handleAssignChipActive(index)}
                          variant="outlined"
                        />
                      ))}
                    </Stack>
                  </div>
                  {assignErrors.assignChip && (
                    <span className="assign-drawer-error">
                      {assignErrors.assignChip}
                    </span>
                  )}
                </div>

                <div className="drawer_checkbox_div">
                  <h6 className="drawer_selecte_content">Hedaer-Check Boxes</h6>
                  <div className="drawer_checkbox">
                    {chipName.map((option, index) => (
                      <FormControlLabel
                        key={index}
                        control={
                          <Checkbox
                            value={option}
                            name="assignCheck"
                            onChange={handleAssignChange}
                            checked={assignData.assignCheck.includes(option)}
                            sx={{
                              color: '#667085', // Change border color
                              '&.Mui-checked': {
                                color: '#00B3F3', // Change checked color
                              },
                            }}
                            inputProps={{ 'aria-label': `checkbox-${index}` }}
                          />
                        }
                        label={
                          <Typography
                            className="radio_assign-typography"
                            sx={{
                              color: assignData.assignCheck.includes(option)
                                ? 'black'
                                : 'rgb(102, 112, 133)',
                            }}
                          >
                            {option}
                          </Typography>
                        }
                      />
                    ))}
                  </div>
                  {assignErrors.assignCheck && (
                    <span className="assign-drawer-error">
                      {assignErrors.assignCheck}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="drawer_btns">
              <Button
                type="button"
                className="drawer_cancel_btn"
                onClick={handleCloseDrawer}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className={`drawer_assign_btn ${isFormValid ? 'assign-btn-valid' : 'drawer_assign_btn'}`}
                disabled={!isFormValid}
              >
                <p
                  className={`drawer_assign_btn-assign ${isFormValid ? 'assign-btn-valid' : 'drawer_assign_btn-assign'}`}
                >
                  Assign
                </p>
              </Button>
            </div>
          </form>
        </div>
      </Drawer>
      <Drawer
        open={filterOpen}
        anchor="right"
        onClose={() => handleFIlterClick(false)}
      >
        <div className="dashboard-filter">
          <div className="dashboard_filter-drawer">
            <div className="dashboard-filter_drawer-head">
              <h4>Filters</h4>
              <h5>Restore</h5>
            </div>
            <div className="dashboard-filter_drawer-select">
              <div className="dashboard-filter_drawer-select-list">
                <FormGroup>
                  <InputLabel id="filter-select-label">Dealer Name</InputLabel>
                  <Select
                    labelId="filter-select-label"
                    id="filter-select"
                    multiple
                    displayEmpty
                    value={dealername}
                    onChange={handleChangeDealerName}
                    renderValue={() => (
                      <div className="filter-select-display">
                        {selectedRoles.length == 0 ? (
                          'Select Options'
                        ) : (
                          <div className="filter-select-display-option">
                            {selectedRoles.slice(0, 2).map((dealer, index) => (
                              <p key={index}>{`${dealer} ,`}</p>
                            ))}
                            {selectedRoles.length > 2 && (
                              <p>{`${selectedRoles[2].slice(0, selectedRoles[2].length / 2)}...`}</p>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                    onClose={() => setFilteredRoles(names)}
                  >
                    <div className="dealername_option_content">
                      <div className="dealername_option_search_content">
                        <TextField
                          className="dealername_option_searchbar search-input"
                          variant="outlined"
                          placeholder="Search dealer names here"
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <SearchIcon className="search_icon" />
                            ),
                          }}
                          onChange={handleRoleUserSearch}
                        />
                      </div>
                      <div className="dealername_option_list_content">
                        {filteredRoles.map((role, index) => (
                          <div key={index} className="dealername_option_list">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedRoles.includes(String(role))}
                                  onChange={() => {
                                    handleRoleSelection(String(role));
                                  }}
                                  sx={{
                                    color: '#667085',
                                    '&.Mui-checked': {
                                      color: '#00B3F3',
                                    },
                                  }}
                                />
                              }
                              label={role}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </Select>
                </FormGroup>
              </div>
              <div className="dashboard-filter_drawer-chipset">
                <h5>Header-Chipsets</h5>
                <div className="dashboard-filter_drawer-chipset-list">
                  <Stack className="dashboard-filter_drawer-stack">
                    {chipName.map((chipName, index) => (
                      <Chip
                        key={index}
                        label={chipName}
                        className={
                          activeChip[index]
                            ? 'dashboard-filter_drawer-stack-list_active'
                            : 'dashboard-filter_drawer-stack-list'
                        }
                        onClick={() => ChipsetActivevalue(index)}
                        deleteIcon={
                          <img
                            src={activeChip[index] ? WhiteCloseicon : Add}
                            alt={activeChip[index] ? 'Cancel' : 'Add'}
                          />
                        }
                        onDelete={() => ChipsetActivevalue(index)}
                        variant="outlined"
                      />
                    ))}
                  </Stack>
                </div>
              </div>
            </div>
          </div>
          <div className="dashboard-filter_drawer-foot">
            <Button
              className="dashboard-filter_drawer-foot-cancel"
              variant="text"
              onClick={() => handleFIlterCancel(false)}
            >
              Cancel
            </Button>
            <Button
              className={`"drawer_assign_btn drawer_assign_btn-assign" ${isFilterValid ? 'dashboard-filter_drawer-foot-apply' : 'drawer_assign_btn drawer_assign_btn-assign'}`}
              variant="contained"
              onClick={handleFillterApply}
              disabled={!isFilterValid}
            >
              Apply
            </Button>
          </div>
        </div>
      </Drawer> */}
    </>
  );
};

export default Dashboard;
